import { FinraException } from "./../finra-exception.model";
import { FinraExceptionService } from "./../finra-exception.service";
import { Component, OnInit, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DrawerModule } from "primeng/drawer";

@Component({
    selector: "app-finra-exception-view",
    imports: [DrawerModule, CommonModule, FormsModule],
    templateUrl: "./finra-exception-view.component.html",
    styleUrls: ["./finra-exception-view.component.scss"]
})
export class FinraExceptionViewComponent implements OnInit {
  @Input() finraException!: FinraException;
  parsedLabelJSON: any;
  parsedValueJSON!: string;
  objectKeys = Object.keys;
  loadingView!: boolean;
  newViewJson = {};
  @Input() fieldDictionaryList!: any[];

  constructor(public finraExceptionService: FinraExceptionService) {}

  ngOnInit() { 
    this.fieldDictionaryList.forEach((element, index) => {
      if (this.fieldDictionaryList[index].jsonValue !== null && this.fieldDictionaryList[index].jsonValue !== "" && (element.fieldName.toLowerCase() === 'timeinforce' || element.fieldName.toLowerCase() === 'selldetails' || 
      element.fieldName.toLowerCase() === 'buydetails' ||element.fieldName.toLowerCase() === 'handlinginstructions' ||
      element.fieldName.toLowerCase() === 'clientdetails' || element.fieldName.toLowerCase() === 'firmdetails' ||
      element.fieldName.toLowerCase() === 'firmdetails' || element.fieldName.toLowerCase() === 'legdetails' || element.fieldName.toLowerCase() === 'aggregatedorders')) {
        this.fieldDictionaryList[index].jsonValue = JSON.stringify(this.fieldDictionaryList[index].jsonValue);
      }
    
    });
  }

   
}
